import React from 'react';

import { container } from './social-widget-link.module.scss';
import { config } from '../../config';
import { ISocialWidgetLink } from '../../models/social-widget-item.model';
import { useTranslation } from '../../hooks/use-translation';

const { translationKeys } = config;

interface ISocialWidgetLinkProps {
    className?: string;
    socialWidgetLink: ISocialWidgetLink;
}

const SocialWidgetLink: React.FC<ISocialWidgetLinkProps> = ({
    className = '',
    socialWidgetLink,
}) => {
    const { url, name } = useTranslation(socialWidgetLink, translationKeys.socialWidgetLink);

    return (
        <a
            className={`${container} ${className}`}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
        >
            {name}
        </a>
    );
};

export default SocialWidgetLink;
